export const CREW_VALIDATION_RULES = {
	isActive: {
		shorthand: 'Crew inactive',
		tooltip: 'Crew member is not active',
	},
	hasCorrectRole: {
		shorthand: 'Incorrect crew role',
		tooltip: 'Crew member does not have the correct role assigned',
	},
	notEnded: {
		shorthand: 'Assignment past active date',
		tooltip: 'Crew member will become inactive before the end of the work assignment',
	},
	medicalCheckIsValid: {
		shorthand: 'Expired medical check validity',
		tooltip: "Crew member's medical check expired",
	},
	drugTestIsValid: {
		shorthand: 'Expired drug test check validity',
		tooltip: "Crew member's drug test expired",
	},
	driverLicenseIsValid: {
		shorthand: 'Expired driver license',
		tooltip: "Crew member's driver license expired",
	},
	driverCardIsValid: {
		shorthand: 'Missing employee number',
		tooltip: 'Crew member ID is missing',
	},
	matchingMobilityPartner: {
		shorthand: 'Mobility partner mismatch',
		tooltip: 'Crew member does not belong to the same mobility partner as the equipment',
	},
	hasHomebase: {
		shorthand: 'No defined domicile',
		tooltip: 'Crew member does not have a defined domicile',
	},
	presentInDepartureLocation: {
		shorthand: 'Not at the departure location',
		tooltip: 'Crew member is not expected at the dispatch location',
	},
	hasEmploymentType: {
		shorthand: 'Missing employment type data',
		tooltip: "Crew member doesn't have a full or part time classification",
	},
};
